# Términos y Condiciones

*Última actualización: 24 de octubre de 2026*

Estos Términos y Condiciones («Términos») regulan el acceso y el uso de la plataforma web **kart.win** ([https://kart.win](https://kart.win)) y de la aplicación móvil **Kart Win Extractor** (`com.yanicksenn.telemetry.extractor`), operadas por **Yanick Senn** («nosotros», «nos» o «nuestro», y en conjunto los «Servicios»).

Al iniciar sesión o utilizar los Servicios, o al hacer clic en «Aceptar», aceptas quedar vinculado por la versión vigente de estos Términos.

---

## 1. Ámbito de aplicación y aceptación

1. **Obligación de aceptación**: Todo usuario autenticado debe aceptar la última versión de estos Términos antes de realizar cualquier acción autenticada dentro de los Servicios.
2. **Actualizaciones de versión**: Siempre que estos Términos se actualicen en una nueva versión, se te solicitará que revises y aceptes los Términos actualizados antes de seguir utilizando las funciones autenticadas.
3. **Política de privacidad**: El uso que hagas de los Servicios también se rige por nuestra [Política de Privacidad](#/privacy), en la que se explica cómo recopilamos, almacenamos y protegemos tus datos personales y de sesiones.

---

## 2. Registro de cuenta y uso aceptable

1. **Credenciales de la cuenta**: Puedes iniciar sesión utilizando los proveedores de identidad externos admitidos (como Iniciar sesión con Apple o Iniciar sesión con Google). Eres responsable de mantener la seguridad de tu cuenta y de cualquier dispositivo conectado o aplicación autorizada.
2. **Uso aceptable**: Te comprometes a utilizar los Servicios únicamente con fines lícitos y de conformidad con estos Términos. No debes:
   - Intentar obtener acceso no autorizado a cuentas, equipos o datos privados de otros usuarios;
   - Interferir, interrumpir o sobrecargar los Servicios, servidores o redes;
   - Realizar ingeniería inversa, descompilar o abusar de cualquier parte de los Servicios o de sus API; ni
   - Subir código malicioso, archivos dañados o contenido ilícito.
3. **Suspensión o cancelación de la cuenta**: Nos reservamos el derecho de suspender o cancelar el acceso a los Servicios en cualquier momento si consideramos razonablemente que has infringido estos Términos o que has comprometido la seguridad o integridad de la plataforma.

---

## 3. Datos del usuario y licencia de contenido

1. **Propiedad**: Conservas todos los derechos de propiedad sobre los datos, archivos, configuraciones y contenidos que subas o introduzcas en los Servicios («Contenido del Usuario»).
2. **Licencia para operar los Servicios**: Al subir o enviar Contenido del Usuario a los Servicios, nos otorgas una licencia mundial, no exclusiva y libre de regalías para alojar, almacenar, procesar, analizar y mostrar dicho Contenido del Usuario únicamente con el propósito de proporcionar, mantener y mejorar los Servicios para ti y para los equipos o usuarios con los que decidas compartir tus datos.
3. **Uso compartido en equipo**: Cuando te unes a un equipo o compartes explícitamente datos con un equipo dentro de los Servicios, los miembros de dicho equipo tendrán acceso para ver los datos compartidos de acuerdo con tu configuración de uso compartido.

---

## 4. Disponibilidad del servicio y exclusión de garantías («Tal cual»)

1. **Prestación «Tal cual»**: Los Servicios y todos los informes, visualizaciones, cálculos y recomendaciones asociados se proporcionan **«TAL CUAL»** («AS IS») y **«SEGÚN DISPONIBILIDAD»** («AS AVAILABLE»), sin garantías de ningún tipo, ya sean expresas, implícitas o legales.
2. **Sin garantía de disponibilidad o exactitud**: Aunque nos esforzamos por ofrecer una alta fiabilidad, no garantizamos que los Servicios funcionen de manera ininterrumpida, libre de errores o completamente exacta en todo momento, ni garantizamos el almacenamiento o la copia de seguridad indefinidos del Contenido del Usuario.

---

## 5. Limitación de responsabilidad

En la máxima medida permitida por la legislación aplicable:

1. **Exclusión de daños indirectos**: En ningún caso **Yanick Senn** será responsable de daños indirectos, incidentales, especiales, consecuentes o punitivos, ni de ninguna pérdida de datos, ingresos, beneficios o fondo de comercio que surja de o esté relacionada con el uso o la imposibilidad de uso de los Servicios.
2. **Responsabilidad máxima**: Nuestra responsabilidad total acumulada por cualquier reclamación que surja de o esté relacionada con estos Términos o los Servicios no superará el importe total abonado por ti (en su caso) por el uso de los Servicios durante los doce (12) meses anteriores al hecho que dio lugar a la reclamación.

---

## 6. Legislación aplicable y jurisdicción

Estos Términos y cualquier controversia o reclamación que surja de o en relación con ellos o con los Servicios se regirán e interpretarán de conformidad con las leyes sustantivas de **Suiza**, con exclusión de sus normas sobre conflicto de leyes. La jurisdicción exclusiva corresponderá a los tribunales competentes del domicilio del operador en Suiza, sin perjuicio de los fueros imperativos legalmente aplicables.

---

## 7. Contacto

Si tienes alguna pregunta sobre estos Términos y Condiciones, puedes ponerte en contacto con:

- **Operador**: Yanick Senn
- **Correo electrónico**: [info@yanicksenn.com](mailto:info@yanicksenn.com)
- **Sitio web**: [https://kart.win](https://kart.win)
